// extracted by mini-css-extract-plugin
export default {"wv_object":"wv_object","wv_iframe":"wv_iframe","wv":"wv"};